import { UserLanguage } from '../../../../features/account/types/User'

export enum ConventionalItemType {
  Category = 'category',
  Genre = 'genre',
  Subgenre = 'subgenre',
}

export type ConventionalTranslatedField = 'name' | 'description' | 'imageText'

export type ConventionalTranslations = Partial<Record<UserLanguage, Partial<Record<ConventionalTranslatedField, string | null>>>>

// `GET conventional/{type}/list`. Every type shares the base; the optional fields belong to genres and subgenres.
export type InternalConventionalItem = {
  id: string
  name: string
  createdAt: number
  modifiedAt: number
  createdBy: string | null
  modifiedBy: string | null
  translations: ConventionalTranslations | null
  genres?: string[]
  subgenres?: string[]
  parentCategory?: string
  parentCategoryId?: string
  parentGenre?: string
  parentGenreId?: string
  rules?: Record<string, number[]>
  description?: string | null
  imageUrl?: string | null
  imageText?: string | null
  exampleAppIds?: number[]
}

// The stored item with the edits on top, plus `translations`, as legacy sends it to `POST i/conventional/{type}`.
export type ConventionalItemMutation = InternalConventionalItem & { translations: ConventionalTranslations }

export type SavedConventionalItem = {
  item?: InternalConventionalItem
  translations: ConventionalTranslations
}
